var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getError(_vm.field))?_c('span',{staticClass:"validation-error",attrs:{"for":"id_identifier_number"}},[_vm._v(_vm._s(_vm.getError(_vm.field)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }